import './Button.css';
export default {
    "root": "Button_root__1p1bh",
    "disabled": "Button_disabled__1p1bh",
    "block": "Button_block__1p1bh",
    "primary": "Button_primary__1p1bh",
    "secondary": "Button_secondary__1p1bh",
    "ghost": "Button_ghost__1p1bh"
};
